import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { EmployeesPage } from './pages/EmployeesPage';
import { EmployeeDetailPage } from './pages/EmployeeDetailPage';
import { TeamsPage } from './pages/TeamsPage';
import { ScreenshotsPage } from './pages/ScreenshotsPage';
import { AppsPage } from './pages/AppsPage';
import { WebsPage } from './pages/WebsPage';
import { ReportsPage } from './pages/ReportsPage';
import { AuditPage } from './pages/AuditPage';
import { AiPage } from './pages/AiPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { SettingsPage } from './pages/SettingsPage';
import { RemoteDesktopPage } from './pages/RemoteDesktopPage';
import { Layout } from './components/Layout';
import { api } from './services/api';

export default function App() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('at_token');
    if (token) {
      api.get('/auth/me').then(r => setUser(r.data))
        .catch(() => { localStorage.removeItem('at_token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogin = (userData: any, token: string) => {
    localStorage.setItem('at_token', token);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('at_token');
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0d0d12' }}>
        <div className="spinner-large" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage onLogin={handleLogin} />} />
        {user ? (
          <Route element={<Layout user={user} onLogout={handleLogout} />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/employees" element={<EmployeesPage />} />
            <Route path="/employees/:id" element={<EmployeeDetailPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/screenshots" element={<ScreenshotsPage />} />
            <Route path="/apps" element={<AppsPage />} />
            <Route path="/webs" element={<WebsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/ai" element={<AiPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/remote" element={<RemoteDesktopPage />} />
            <Route path="/remote/:userId" element={<RemoteDesktopPage />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}
